export default {
  error: false,
  errorMessage: '',
  charging: false,
  about: "",
  childStars: [],
  avatarImages: [],
  CriterionDescription: "",
  faq: {
    posts: [],
    topics: []
  }
}